export default "__VITE_ASSET__NY6VVdzO__"